/* app/js/src/components/live-sources/live-sources-toolbar/live-sources-toolbar.component.scss */
.cursor-pointer {
  cursor: pointer;
}
.live-sources-toolbar {
  display: flex;
  flex-direction: column;
  align-items: stretch;
  padding: 0;
}
.live-sources-toolbar__filters-row {
  display: flex;
  align-items: flex-end;
  justify-content: flex-start;
  gap: 12px;
  padding-bottom: 0;
}
.live-sources-toolbar__search-wrapper {
  position: relative;
  display: flex;
  align-items: center;
  min-width: 280px;
  max-width: 400px;
}
.live-sources-toolbar__search-wrapper ichannel-input {
  flex: 1;
}
.live-sources-toolbar__search-wrapper ::ng-deep ichannel-input > div.rowInput,
.live-sources-toolbar__search-wrapper ::ng-deep ichannel-input > div {
  margin-bottom: 0;
}
.live-sources-toolbar__clear {
  margin-left: 8px;
  background: none;
  border: none;
  font-size: 18px;
  color: rgba(0, 0, 0, 0.54);
  cursor: pointer;
  padding: 0 4px;
  line-height: 1;
}
.live-sources-toolbar__clear:hover {
  color: rgba(0, 0, 0, 0.85);
}
.live-sources-toolbar__status-dropdown {
  min-width: 140px;
}
.live-sources-toolbar__protocol-dropdown {
  min-width: 140px;
}
/*# sourceMappingURL=live-sources-toolbar.component.css.map */
